/* ========== ~~~~~~~~~~ EMBEDS STATE > EMBED MANAGEMENT STATE > EMBED MANAGEMENT STATUS: ACTIONS ~~~~~~~~~~ ========== */
// ACTION
// utilized by reducers as a call to action to perform some kind of update to application state
// utilized in "_container" components and reducers


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const UPDATE_STEP_DETAILS = 'UPDATE_STEP_DETAILS';

// update store with new step values based on some cta to navigate
export const updateStepDetails = step => ({
    type: UPDATE_STEP_DETAILS,
    step
});